/**
 * @Author: 左建
 * @Date: 2022/12/6 16:00
 * @LastEditTime: 2022/12/6 16:00
 * @Description: addPaper 的引导页
 */
import Driver from "driver.js"
import "driver.js/dist/driver.min.css"
// 初始化
const driver = new Driver({
    className: "driver-class", // className to wrap driver.js popover
    animate: true, // Animate while changing highlighted element
    opacity: 0.75, // Background opacity (0 means only popovers and without overlay)
    padding: 10, // Distance of element from around the edges
    allowClose: true, // Whether clicking on overlay should close or not
    overlayClickNext: true, // Should it move to next step on overlay click
    doneBtnText: "完成", // Text on the final button
    closeBtnText: "关闭", // Text on the close button for this step
    nextBtnText: "下一步", // Next button text for this step
    prevBtnText: "上一步", // Previous button text for this step
    showButtons: true, // Do not show control buttons in footer
    keyboardControl: true, // Allow controlling through keyboard (escape to close, arrow keys to move)
    scrollIntoViewOptions: {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    }, // We use `scrollIntoView()` when possible, pass here the options for it if you want any
    // 当元素即将变为高亮时
    onHighlightStarted: (Element) => {
        // console.log(Element, "onHighlightStarted")
    },
    // 当元素已经变为高亮时会在onDeselected之后触发
    onHighlighted: (Element) => {
        // console.log(Element, "onHighlighted")
    },
    // 上一步选择的元素会在onHighlightStarted之后触发（第一步不会触发）
    onDeselected: (Element) => {
        // console.log(Element, "onDeselected")
    },
    // 遮罩即将关闭时触发
    onReset: (Element) => {
        // console.log(Element, "onReset")
    },
    // 点击下一步触发的回调
    onNext: (Element) => {
        // console.log(Element, "onNext")
    },
    // 点击上一步触发的回调
    onPrevious: (Element) => {
        // console.log(Element, "onPrevious")
    }
})

export function start () {
    driver.defineSteps([
        {
            element: "#paper-import-driver-add-paper-step-one",
            popover: {
                title: "第一步完善考试信息",
                description: "请完善考试基本信息，再添加试卷题型",
                // position can be left, left-center, left-bottom, top,
                // top-center, top-right, right, right-center, right-bottom,
                // bottom, bottom-center, bottom-right, mid-center
                position: "bottom",
            }
        }
    ]);
    driver.start()
}

export default start
